import React from "react";
import { Platform } from "react-native";
import { createSwitchNavigator } from "@react-navigation/core";
import { createAppContainer } from "react-navigation";
import { createBrowserApp } from "@react-navigation/web";

import { _setNavigator } from "./navigator";
import routes from "./routes";

const navigator = createSwitchNavigator(routes);
const App =
  Platform.OS === "web"
    ? createBrowserApp(navigator)
    : createAppContainer(navigator);

const Router = () => <App ref={navRef => _setNavigator(navRef)} />;

export * from "./navigator";
export * from "./protected-route";
export default Router;
